import { cn } from "@/lib/utils";

/**
 * No microdata here: the wrapper used to declare a bare `schema.org/Place` with
 * nothing but a `description`, which Google parsed as a second, nameless place
 * on a page that is already about one business. The description is published
 * through the venue's `LocalBusiness` JSON-LD instead.
 */
export default function AboutDescription({
  description,
}: {
  description: string;
}) {
  return (
    <div className="w-full flex flex-col items-center relative">
      <div
        className={cn("text-primary font-medium custom-content-styles")}
        dangerouslySetInnerHTML={{
          __html: description,
        }}
      />
    </div>
  );
}
